















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ParametersOverrideFilterList from '@/components/parameters/override/filter-list.vue';
import ParametersOverrideList from '@/components/parameters/override/list.vue';
import ParameterModel from '@/models/parameter-model';

@Component({
  components: {
    PermissionAuth,
    ParametersOverrideFilterList,
    ParametersOverrideList,
  },
})
export default class ParametersOverrides extends BaseComponent {
  @Prop(ParameterModel)
  public parameter?: ParameterModel;

  public filter: any = {};

  public onFilter(filter: any): void {
    this.filter = filter;
  }

  @Watch('parameter')
  public inicializandoParametro(){
    this.filter.parameter = this.parameter;    
  }

  public onCloseClick(): void {
    this.$emit('close'); 
  }
}
